<template>
    <v-container>
        <v-card v-if="submitted_schedule && submitted_schedule.state.toLowerCase() == 'approved'" class="mx-auto my-12"
            max-width="400">
            <v-img height="250" src="crisis-logo.jpeg"></v-img>
            <v-card-title class="text-uppercase">Hello {{ full_name }}, good day ☀️ </v-card-title>
            <v-card-text>
                <div class="my-4 subtitle-1">
                    📅 Gentle Reminder
                </div>
                <div>Take note of your appointment schedule and session via the ZOOM app. Click the meeting link below:
                    <br />
                    <span class="text-h6 blue--text">
                        🔗 <a class="ml-2" :href="submitted_schedule.link">Meeting Link</a>
                    </span> <br />
                </div>
                <br />
                <span class="font-weight-light text-caption">Note: zoom meeting link may only be availble up to 45 mins
                    only</span>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-title>You are scheduled at :</v-card-title>

            <v-card-text>
                <v-chip-group active-class="deep-purple accent-4 white--text" column>
                    <v-chip large class="text-h6 deep-purple accent-4 white--text">{{
                        format_to_date(submitted_schedule.date)
                    }}</v-chip>
                </v-chip-group>
            </v-card-text>

            <v-card-actions>
                <v-btn color="deep-purple lighten-2" text @click="cancel">
                    Cancel
                </v-btn>
                <v-btn color="deep-purple lighten-2" text @click="book_another">
                    Book Another
                </v-btn>

            </v-card-actions>
        </v-card>
        <v-card v-if="submitted_schedule && submitted_schedule.state == 'Pending Approval'" class="mx-auto my-12"
            max-width="374">
            <v-img height="250" src="crisis-logo.jpeg"></v-img>

            <v-card-title>Maligayang araw, {{ full_name }} </v-card-title>

            <v-card-text>
                Salamat sa pagsagot ng form. Makasisiguro po kayong ang lahat ng ibinahagi ninyong impormasyon ay
                mananatiling kumpidensiyal (confidential). Hintayin lamang ang aming kumpirmasyon sa pamamagitan ng
                e-mail at text (SMS).
                Para sa inyong mga katanungan at iba pang concerns, mangyaring paki-email kami sa <span
                    class="blue--text">mhusaptayo@gmail.com</span>.
                Muli, maraming salamat sa inyong dedikasyon at serbisyo! Patuloy po tayong mag-ingat at manatiling
                ligtas.
                <br />
                <br />
                <br />
                Sama-sama para sa bayan, <br />
                NCMH Telemental Health Support Team (TMH Team)

            </v-card-text>

        </v-card>
        <v-spacer></v-spacer>
        <!-- Dialog box for the checklist -->
        <v-card v-if="!submitted_schedule">
            <v-card-title>
                Available Appointment Schedules
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
                </v-text-field>
            </v-card-title>

            <v-data-table v-model="selected" :loading="isFetchingData" :headers="headers" :items="schedules"
                :search="search" single-select show-select item-key="date_available" class="elevation-1">
                <!-- Used formatted date in display -->>
                <template v-slot:item.date_available="{ item }">
                    <span>{{ item.date }}</span>
                </template>

            </v-data-table>
            <v-card-actions>
                <v-spacer />
                <v-dialog v-model="checklistDialog" persistent max-width="700px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-tooltip top :disabled="selected.length > 0">
                            <template v-slot:activator="{ on: tooltipOn }">
                                <div v-on="tooltipOn" class="d-inline-block">
                                    <v-btn color="secondary" class="text--primary"
                                        :dark="selected.length > 0" :disabled="selected.length === 0"
                                        v-bind="attrs" v-on="on">
                                        <v-icon>mdi-calendar-check</v-icon>
                                        Book Schedule
                                    </v-btn>
                                </div>
                            </template>
                            <span>Select a schedule from the table first</span>
                        </v-tooltip>
                    </template>

                    <v-card>
                        <v-card-title class="justify-center">
                            Book an appointment
                        </v-card-title>
                        <v-stepper alt-labels v-model="e1">
                            <v-stepper-header>
                                <v-stepper-step step="1">
                                    Reason for consult
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step step="2">
                                    Terms and conditions
                                </v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card class="mb-12" max-height="300px" flat>
                                        <v-textarea filled label="Reason for consult" v-model="reason"
                                            :rules="textRules" counter="200" maxlength="200" required></v-textarea>
                                    </v-card>
                                    <v-btn color="primary" @click="e1 = 2"
                                        :disabled="!(reason.length >= 50 && reason.length < 200)">
                                        Continue
                                    </v-btn>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-card class="mb-12" max-height="300px" flat>
                                        <v-card-text>
                                            Please read on the terms and condition prior to
                                            proceeding
                                        </v-card-text>
                                        <v-container>
                                            <v-row justify="center">
                                                <v-dialog v-model="termsAgreementDialog" width="600px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn color="green" dark v-bind="attrs" v-on="on">
                                                            Agree on Terms and Condition
                                                        </v-btn>
                                                    </template>
                                                    <v-card>
                                                        <v-card-title>
                                                            <span class="headline"><strong>Informed
                                                                    Consent</strong></span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            Please read and understand the following before you proceed:
                                                            <br />
                                                            <i>(Pakibasa at unawain ang mga sumusunod bago kayo
                                                                magpatuloy:)</i>

                                                        </v-card-text>

                                                        <v-card-title>
                                                            <span class="headline">Telemental Health</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            With the national guidelines related to the COVID-19
                                                            pandemic,
                                                            NCMH
                                                            Wellness and Crisis Center added telemental health to its
                                                            services,
                                                            which makes use of online- and/or phone-based applications
                                                            or
                                                            programs
                                                            for interactive video and data communications.
                                                            <br /><br />
                                                            It is important to note that telecounseling may present a
                                                            different
                                                            therapeutic experience compared to face-to-face
                                                            psychotherapy/counseling. If in case any of the latter is
                                                            preferred,
                                                            referral to mental health professionals may be facilitated.
                                                        </v-card-text>
                                                        <v-card-title>
                                                            <span class="headline">Referral Services</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            Client openness and active participation are imperative to
                                                            progress. As
                                                            therapy entails the sharing of personal and sensitive
                                                            information, there
                                                            may be periods of increased emotionality and/or confusion
                                                            during
                                                            the
                                                            course of telecounselling. Our Mental Health Providers
                                                            (MHPs)
                                                            are
                                                            trained to build trust so if you experience any discomfort
                                                            with
                                                            the
                                                            process, communicate this to your MHP for processing.
                                                            <br /><br />
                                                            When deemed necessary, our MHP may facilitate referrals to
                                                            the
                                                            appropriate mental health professional/s with consent for
                                                            further
                                                            evaluation and management.
                                                        </v-card-text>
                                                        <v-card-title>
                                                            <span class="headline">On Privacy and Connectivity</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            The MHP and client shall employ all possible efforts to
                                                            ensure
                                                            privacy
                                                            by making use of reliable and secured platforms, and by
                                                            holding
                                                            the
                                                            session in a private, quiet room.
                                                            <br /><br />
                                                            Malicious and/or unauthorized disclosure of any information
                                                            (ie.
                                                            privileged communication, personal information, pictures,
                                                            video
                                                            recordings, etc.) of both client and mental health provider,
                                                            shall be
                                                            punishable under RA 10173 (Data Privacy Act), the Revised
                                                            Penal
                                                            Code, RA
                                                            10175 (Cybercrime Prevention Act of 2012), and other
                                                            relevant
                                                            laws.
                                                            <br /><br />
                                                            As telecounseling makes use of Internet and/or mobile
                                                            connectivity, the
                                                            possibility of technical failures may be expected, despite
                                                            reasonable
                                                            efforts from both parties. It is the client’s responsibility
                                                            to
                                                            inform
                                                            the MHP of their availability to commence the video call.
                                                            The
                                                            appointment may be rescheduled if technical failures occur.
                                                        </v-card-text>
                                                        <v-card-title>
                                                            <span class="headline">Appointments & Cancellations</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            Telecounseling sessions are scheduled on a per-appointment
                                                            basis
                                                            as
                                                            determined by the TMH Team. Advise your MHP or the TMH Team
                                                            ahead of
                                                            time if you will be late. However, we encourage you to be on
                                                            time as
                                                            being late may have an impact on the duration of the session
                                                            (which is
                                                            only limited for 30 minutes up to 1 hour)
                                                            <br /><br />
                                                            Rescheduling or cancellations are made at least 12-hours
                                                            before
                                                            the
                                                            appointment, except for emergency situations that are not
                                                            under
                                                            the
                                                            control of either party (e.g. sickness, natural calamities,
                                                            government
                                                            suspensions, etc.). Two consecutive “no-shows” or
                                                            unjustifiable
                                                            cancellations, or failure to respond to text messages within
                                                            3
                                                            days,
                                                            merit discontinuation of services.
                                                            <br /><br />
                                                            Nonetheless, you are welcome to sign up for telecounseling
                                                            again
                                                            in the
                                                            future. You may likewise withdraw from therapy at any time
                                                            by
                                                            providing
                                                            notice to your MHPs.
                                                            <br /><br />
                                                            Frequent non-compliance to the scheduled appointment may be
                                                            grounds for
                                                            termination of services.
                                                            <br /><br />
                                                            Failure to comply with any form of treatment plan provided
                                                            by
                                                            MHP may be
                                                            grounds for termination of services.
                                                            <br /><br />
                                                            (Note: It is the client’s responsibility to inform the TMH
                                                            Team
                                                            of any
                                                            change in contact details.)
                                                        </v-card-text>
                                                        <v-card-title>
                                                            <span class="headline">Use & Disclosure of Health
                                                                Information</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            Personal information, content of sessions, and progress
                                                            notes
                                                            are kept
                                                            confidential and secured. All parties are not allowed to
                                                            audio
                                                            and/or
                                                            video-record any portion of the session unless agreed upon
                                                            in a
                                                            separate
                                                            formal written agreement.
                                                            All interactions, which include personal information,
                                                            content of
                                                            sessions, and progress notes, are confidential EXCEPT:
                                                            <br /><br />
                                                            <ul>
                                                                <li>During internal case conferences and consultations
                                                                    with
                                                                    NCMH
                                                                    clinical supervisors, to ensure the best possible
                                                                    care
                                                                    for every
                                                                    client; and</li>
                                                                <br />
                                                                <li>If there is evidence of clear and imminent danger to
                                                                    self and/or
                                                                    others, whereby the MHPs are ethically required to
                                                                    report this
                                                                    information to the authorities responsible for
                                                                    ensuring
                                                                    safety.
                                                                </li>
                                                            </ul>
                                                            <br />
                                                            The Mental Health Provider may facilitate referrals to
                                                            appropriate
                                                            service providers for further evaluation and management. MHP
                                                            may
                                                            also
                                                            facilitate follow-ups for continuing care sessions with the
                                                            same
                                                            Service-user.
                                                            <br /><br />
                                                            Information about clients may be disclosed in consultations
                                                            with
                                                            the TMH
                                                            Team in order to provide the best possible
                                                            approach/treatment.
                                                            In such
                                                            cases, the name of the client or any identifying information
                                                            is
                                                            not
                                                            disclosed. Case details/clinical information about the
                                                            client is
                                                            discussed.
                                                            <br /><br />
                                                            When client disclosed intentions or plans to harm another
                                                            person, MHP is
                                                            required to warn the intended victim and report this
                                                            information
                                                            to
                                                            legal authorities. In cases when client discloses or implies
                                                            a
                                                            plan for
                                                            suicide, MHP is required to notify legal authorities and
                                                            make
                                                            reasonable
                                                            attempts to notify the family of the client.
                                                            <br /><br />
                                                            Any other disclosure of health information to a third party,
                                                            including
                                                            requests from a branch, agency or instrumentality of the
                                                            government,
                                                            SHALL NOT BE ALLOWED except if pursuant to the lawful order
                                                            of
                                                            the
                                                            court, or to protect public order and safety as may be
                                                            prescribed by
                                                            law, or in cases of emergency to protect life and health of
                                                            patient when
                                                            patient is unable to physically or legally give consent to
                                                            the
                                                            processing.
                                                            <br /><br />
                                                            The confidentiality of privileged information may be invoked
                                                            in
                                                            accordance with the provisions of the Rules of Court, and
                                                            disclosure to
                                                            any third party of privileged information may be allowed
                                                            only if
                                                            with
                                                            consent of parties to the exchange.
                                                        </v-card-text>
                                                        <v-card-title>
                                                            <span class="headline">Understanding, informed consent, and
                                                                limits to
                                                                confidentiality</span>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <ol>
                                                                <li>DI accept and unconditionally agree to undergo
                                                                    services
                                                                    provided
                                                                    by the TMH Team.</li>
                                                                <li>I agree, without any condition whatsoever and on my
                                                                    own
                                                                    to
                                                                    undergo and subject myself to the services of and to
                                                                    be
                                                                    undertaken on my person by the TMH Team.</li>
                                                                <li>I understand that active participation and openness
                                                                    is
                                                                    required
                                                                    to make progress.</li>
                                                                <li>I understand that it is my responsibility to inform
                                                                    the
                                                                    Mental
                                                                    Health Provider if there are any significant changes
                                                                    in
                                                                    my
                                                                    physical/emotional condition.</li>
                                                                <li>I understand the potential risks and benefits of the
                                                                    session/s
                                                                    and it cannot be guaranteed that I will feel better
                                                                    after
                                                                    completion of each session.</li>
                                                                <li>I understand that attendance is essential to the
                                                                    success
                                                                    of the
                                                                    session/s.</li>
                                                                <li>I understand that services will be free of charge.
                                                                </li>
                                                                <li>I understand that any information provided shall be
                                                                    kept
                                                                    with
                                                                    utmost confidentiality.</li>
                                                                <li>I understand that any communication with the Mental
                                                                    Health
                                                                    Provider shall be kept with utmost confidentiality.
                                                                </li>
                                                                <li>I understand that malicious and/or unauthorized
                                                                    disclosure of
                                                                    any information (ie. privilege communication,
                                                                    pictures,
                                                                    videos,
                                                                    etc.) with my Mental Health Provider shall be
                                                                    punishable
                                                                    under
                                                                    RA 10173 (Data Privacy Act), Revised Penal Code, and
                                                                    RA
                                                                    10175
                                                                    (Cybercrime Prevention Act of 2012).</li>
                                                            </ol>
                                                            <br /><br />
                                                            <v-divider />
                                                            By clicking the <span
                                                                class="green--text"><strong>AGREE</strong></span>
                                                            button below, you agree to the above-mentioned conditions
                                                            and
                                                            understand
                                                            their meanings and ramifications.

                                                        </v-card-text>

                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="green darken-1" text
                                                                @click="termsAgreementDialog = false">Disagree</v-btn>
                                                            <v-btn color="green darken-1" text
                                                                @click="agreeTerms">Agree</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </v-row>
                                        </v-container>

                                    </v-card>

                                    <v-btn text @click="e1 = 1">
                                        Back
                                    </v-btn>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>

                                    <v-btn text @click="e1 = 2">
                                        Back
                                    </v-btn>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>

                        <!-- <v-card-text>
                            <v-container>
                                  <span class="body-1 mt-8">Please read on the terms and condition prior to proceeding</span>
                                <v-row justify="center">
                                    <v-dialog v-model="termsAgreementDialog" width="600px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="green" dark v-bind="attrs" v-on="on">
                                                Agree on Terms and Condition
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline"><strong>Informed Consent</strong></span>
                                            </v-card-title>
                                            <v-card-text>
                                                Please read and understand the following before you proceed:
                                                <br />
                                                <i>(Pakibasa at unawain ang mga sumusunod bago kayo magpatuloy:)</i>

                                            </v-card-text>

                                            <v-card-title>
                                                <span class="headline">Telemental Health</span>
                                            </v-card-title>
                                            <v-card-text>
                                                With the national guidelines related to the COVID-19 pandemic, NCMH
                                                Wellness and Crisis Center added telemental health to its services,
                                                which makes use of online- and/or phone-based applications or programs
                                                for interactive video and data communications.
                                                <br /><br />
                                                It is important to note that telecounseling may present a different
                                                therapeutic experience compared to face-to-face
                                                psychotherapy/counseling. If in case any of the latter is preferred,
                                                referral to mental health professionals may be facilitated.
                                            </v-card-text>
                                            <v-card-title>
                                                <span class="headline">Referral Services</span>
                                            </v-card-title>
                                            <v-card-text>
                                                Client openness and active participation are imperative to progress. As
                                                therapy entails the sharing of personal and sensitive information, there
                                                may be periods of increased emotionality and/or confusion during the
                                                course of telecounselling. Our Mental Health Providers (MHPs) are
                                                trained to build trust so if you experience any discomfort with the
                                                process, communicate this to your MHP for processing.
                                                <br /><br />
                                                When deemed necessary, our MHP may facilitate referrals to the
                                                appropriate mental health professional/s with consent for further
                                                evaluation and management.
                                            </v-card-text>
                                            <v-card-title>
                                                <span class="headline">On Privacy and Connectivity</span>
                                            </v-card-title>
                                            <v-card-text>
                                                The MHP and client shall employ all possible efforts to ensure privacy
                                                by making use of reliable and secured platforms, and by holding the
                                                session in a private, quiet room.
                                                <br /><br />
                                                Malicious and/or unauthorized disclosure of any information (ie.
                                                privileged communication, personal information, pictures, video
                                                recordings, etc.) of both client and mental health provider, shall be
                                                punishable under RA 10173 (Data Privacy Act), the Revised Penal Code, RA
                                                10175 (Cybercrime Prevention Act of 2012), and other relevant laws.
                                                <br /><br />
                                                As telecounseling makes use of Internet and/or mobile connectivity, the
                                                possibility of technical failures may be expected, despite reasonable
                                                efforts from both parties. It is the client’s responsibility to inform
                                                the MHP of their availability to commence the video call. The
                                                appointment may be rescheduled if technical failures occur.
                                            </v-card-text>
                                            <v-card-title>
                                                <span class="headline">Appointments & Cancellations</span>
                                            </v-card-title>
                                            <v-card-text>
                                                Telecounseling sessions are scheduled on a per-appointment basis as
                                                determined by the TMH Team. Advise your MHP or the TMH Team ahead of
                                                time if you will be late. However, we encourage you to be on time as
                                                being late may have an impact on the duration of the session (which is
                                                only limited for 30 minutes up to 1 hour)
                                                <br /><br />
                                                Rescheduling or cancellations are made at least 12-hours before the
                                                appointment, except for emergency situations that are not under the
                                                control of either party (e.g. sickness, natural calamities, government
                                                suspensions, etc.). Two consecutive “no-shows” or unjustifiable
                                                cancellations, or failure to respond to text messages within 3 days,
                                                merit discontinuation of services.
                                                <br /><br />
                                                Nonetheless, you are welcome to sign up for telecounseling again in the
                                                future. You may likewise withdraw from therapy at any time by providing
                                                notice to your MHPs.
                                                <br /><br />
                                                Frequent non-compliance to the scheduled appointment may be grounds for
                                                termination of services.
                                                <br /><br />
                                                Failure to comply with any form of treatment plan provided by MHP may be
                                                grounds for termination of services.
                                                <br /><br />
                                                (Note: It is the client’s responsibility to inform the TMH Team of any
                                                change in contact details.)
                                            </v-card-text>
                                            <v-card-title>
                                                <span class="headline">Use & Disclosure of Health Information</span>
                                            </v-card-title>
                                            <v-card-text>
                                                Personal information, content of sessions, and progress notes are kept
                                                confidential and secured. All parties are not allowed to audio and/or
                                                video-record any portion of the session unless agreed upon in a separate
                                                formal written agreement.
                                                All interactions, which include personal information, content of
                                                sessions, and progress notes, are confidential EXCEPT:
                                                <br /><br />
                                                <ul>
                                                    <li>During internal case conferences and consultations with NCMH
                                                        clinical supervisors, to ensure the best possible care for every
                                                        client; and</li>
                                                    <br />
                                                    <li>If there is evidence of clear and imminent danger to self and/or
                                                        others, whereby the MHPs are ethically required to report this
                                                        information to the authorities responsible for ensuring safety.
                                                    </li>
                                                </ul>
                                                <br />
                                                The Mental Health Provider may facilitate referrals to appropriate
                                                service providers for further evaluation and management. MHP may also
                                                facilitate follow-ups for continuing care sessions with the same
                                                Service-user.
                                                <br /><br />
                                                Information about clients may be disclosed in consultations with the TMH
                                                Team in order to provide the best possible approach/treatment. In such
                                                cases, the name of the client or any identifying information is not
                                                disclosed. Case details/clinical information about the client is
                                                discussed.
                                                <br /><br />
                                                When client disclosed intentions or plans to harm another person, MHP is
                                                required to warn the intended victim and report this information to
                                                legal authorities. In cases when client discloses or implies a plan for
                                                suicide, MHP is required to notify legal authorities and make reasonable
                                                attempts to notify the family of the client.
                                                <br /><br />
                                                Any other disclosure of health information to a third party, including
                                                requests from a branch, agency or instrumentality of the government,
                                                SHALL NOT BE ALLOWED except if pursuant to the lawful order of the
                                                court, or to protect public order and safety as may be prescribed by
                                                law, or in cases of emergency to protect life and health of patient when
                                                patient is unable to physically or legally give consent to the
                                                processing.
                                                <br /><br />
                                                The confidentiality of privileged information may be invoked in
                                                accordance with the provisions of the Rules of Court, and disclosure to
                                                any third party of privileged information may be allowed only if with
                                                consent of parties to the exchange.
                                            </v-card-text>
                                            <v-card-title>
                                                <span class="headline">Understanding, informed consent, and limits to
                                                    confidentiality</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <ol>
                                                    <li>DI accept and unconditionally agree to undergo services provided
                                                        by the TMH Team.</li>
                                                    <li>I agree, without any condition whatsoever and on my own to
                                                        undergo and subject myself to the services of and to be
                                                        undertaken on my person by the TMH Team.</li>
                                                    <li>I understand that active participation and openness is required
                                                        to make progress.</li>
                                                    <li>I understand that it is my responsibility to inform the Mental
                                                        Health Provider if there are any significant changes in my
                                                        physical/emotional condition.</li>
                                                    <li>I understand the potential risks and benefits of the session/s
                                                        and it cannot be guaranteed that I will feel better after
                                                        completion of each session.</li>
                                                    <li>I understand that attendance is essential to the success of the
                                                        session/s.</li>
                                                    <li>I understand that services will be free of charge.</li>
                                                    <li>I understand that any information provided shall be kept with
                                                        utmost confidentiality.</li>
                                                    <li>I understand that any communication with the Mental Health
                                                        Provider shall be kept with utmost confidentiality.</li>
                                                    <li>I understand that malicious and/or unauthorized disclosure of
                                                        any information (ie. privilege communication, pictures, videos,
                                                        etc.) with my Mental Health Provider shall be punishable under
                                                        RA 10173 (Data Privacy Act), Revised Penal Code, and RA 10175
                                                        (Cybercrime Prevention Act of 2012).</li>
                                                </ol>
                                                <br /><br />
                                                <v-divider />
                                                By clicking the <span class="green--text"><strong>AGREE</strong></span>
                                                button below, you agree to the above-mentioned conditions and understand
                                                their meanings and ramifications.

                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" text
                                                    @click="termsAgreementDialog = false">Disagree</v-btn>
                                                <v-btn color="green darken-1" text @click="agreeTerms">Agree</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                            </v-container>
                            <div class="error-msg" v-if="noSelectedSchedule">
                                Please select schedule first
                            </div>
                            <div class="error-msg" v-if="errorMessage">
                                Error sending the appointment. {{ errorMessage }}
                            </div>

                        </v-card-text> -->
                        <v-card-actions>
                            <span v-if="bookingHint" class="booking-hint text-caption">
                                <v-icon x-small color="grey darken-1">mdi-information-outline</v-icon>
                                {{ bookingHint }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="cancel_request">Close</v-btn>
                            <v-btn color="blue darken-1" text @click="submit_schedule"
                                :disabled="!isBookingEnabled">Submit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-card-actions>
        </v-card>

    </v-container>
</template>

<script>
import moment from 'moment'

import {
    get_available_schedules,
    post_user_schedule
} from '../api'
import store from '../store'
import logger, { describeApiError } from '../utils/logger'

export default {
    data() {
        return {
            e1: 1,
            termsAgreed: false,
            errorMessage: '',
            isFetchingData: true,
            noReason: false,
            'disableSubmit': true,
            'checklistDialog': false,
            'termsAgreementDialog': false,
            'search': '',
            'selected': [],
            'full_name': 'Anonymous User',
            'submitted_schedule': null,
            'schedules': [],
            'isTroubleSleeping': false,
            'isProblemAppetite': false,
            'isFeelHigh': false,
            'isMoreEnergetic': false,
            'isConsistentlyDepressed': false,
            'havePanicAttack': false,
            'isFreqWorried': false,
            'hasSuicidalThoughts': false,
            'hasSuicideAttempt': false,
            'isHurtingYourselfTendency': false,
            'isIrritable': false,
            'hasVoiceWhispering': false,
            'hasNoEmpathyToYou': false,
            'hasPeopleIllFeelings': false,
            'reason': '',
            'headers': [{
                text: 'Date',
                align: 'start',
                sortable: true,
                value: 'date_available',
            },
            {
                text: 'Day',
                value: 'day',
            },
            {
                text: 'Time',
                value: 'time',
            },
            {
                text: 'Available Slots',
                value: 'count',
            },
            {
                text: 'Formatted Date',
                value: 'formatted_date',
                align: ' d-none'
            },

            ],
            noSelectedSchedule: false,
        }
    },
    methods: {
        cancel_request: function () {
            this.checklistDialog = false
            this.noSelectedSchedule = false
        },
        submit_schedule: function () {
            this.noReason = false
            this.noSelectedSchedule = false
            if (this.selected === undefined || this.selected.length == 0) {
                this.noSelectedSchedule = true
                return
            }
            this.checklistDialog = false
            const jwt = store.getters.getJwt
            var sched = {
                appointment_date: this.selected[0].date_available,
                reason: this.reason,
            }
            post_user_schedule(jwt, {
                'schedule': sched,
                'reason': this.reason,
            }).then((() => {
                this.$router.go()
            })).catch(error => {
                logger.error('User', 'Failed to book appointment', describeApiError(error))
                store.dispatch('notification/notifyError', error)
            })

        },
        cancel: function () {
        },
        book_another: function () {
        },
        format_to_date: function (date) {
            return moment(date).format('lll')
        },
        agreeTerms: function () {
            this.termsAgreed = true
            this.termsAgreementDialog = false
        },

    },
    mounted() {
        const jwt = store.getters.getJwt
        get_available_schedules(jwt).then(response => {
            this.full_name = response.data.full_name
            if (response.data.submitted_schedule) {
                this.submitted_schedule = response.data.submitted_schedule
                return
            }
            for (var sched of response.data.schedules) {
                var date_schedule = moment(sched.date_available)
                sched.time = date_schedule.format('h:mm A')
                sched.day = date_schedule.format('dddd')
                sched.date = date_schedule.format('MMM D, YYYY')
                sched.formatted_date = this.format_to_date(sched.date_available)
                this.schedules.push(sched)
            }
            this.isFetchingData = false

        })
    },
    computed: {
        isBookingEnabled() {
            return this.selected.length > 0 && this.termsAgreed && this.reason.length > 0
        },
        bookingHint() {
            if (this.selected.length === 0) {
                return 'Select a schedule from the table to continue'
            }
            if (this.reason.length === 0) {
                return 'Add a reason for consult to continue'
            }
            if (!this.termsAgreed) {
                return 'Agree to the terms and conditions to continue'
            }
            return ''
        },
        textRules() {
            return [
                v => !!v || 'Text is required',
                v => (v && v.length >= 50) || 'Minimum 50 characters required',
                v => (v && v.length <= 200) || 'Maximum 200 characters only',
            ];
        },
    }

}
</script>

<style scoped>
.error-msg {
    color: red;
    font-weight: bold;
}

.booking-hint {
    color: rgba(0, 0, 0, 0.6);
    padding-left: 8px;
}
</style>
